$(document).ready(function () {
    if (document.getElementById("researchersPlans") === null) {
        return
    }

    let researchersSlider = new Swiper("#researchersPlans", {
        slidesPerView: "auto",
        speed: 1000,
    });
});
